import { useState, useEffect } from 'react';
import Layout from '../components/shared/Layout';
import { getCreditPacks, createCheckout } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './CreditsPage.css';

export default function CreditsPage() {
  const { agent } = useAuth();
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buying, setBuying] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getCreditPacks().then(res => setPacks(res.data)).finally(() => setLoading(false));
  }, []);

  const handleBuy = async (pack) => {
    setBuying(pack.id); setError('');
    try {
      const res = await createCheckout(pack.id);
      window.location.href = res.data.checkout_url;
    } catch {
      setError('Could not start checkout. Please try again.');
      setBuying(null);
    }
  };

  const formatPrice = (cents) => `$${(cents / 100).toFixed(0)}`;
  const perReport   = (cents, credits) => `$${(cents / credits / 100).toFixed(2)}/report`;

  const POPULAR_INDEX = 1;

  return (
    <Layout>
      <div style={{maxWidth: 860, margin: '0 auto'}}>
        <div style={{textAlign:'center', marginBottom: 40}}>
          <h1 style={{fontSize: 28, fontWeight: 800, marginBottom: 8}}>Buy Report Credits</h1>
          <p style={{color:'var(--gray-400)', fontSize:15}}>
            No subscriptions. Buy what you need, use them when you want.
          </p>
          <div style={{marginTop:12, display:'inline-flex', alignItems:'center', gap:8,
            background:'var(--gray-100)', borderRadius:20, padding:'6px 18px', fontSize:14}}>
            Current balance: <strong style={{color:'var(--navy)', fontSize:16}}>{agent?.credits ?? 0} credits</strong>
          </div>
        </div>

        {error && <div className="alert alert-error" style={{maxWidth:420, margin:'0 auto 24px'}}>{error}</div>}

        {loading ? (
          <div style={{textAlign:'center', padding:48}}><div className="spinner spinner-dark" style={{margin:'0 auto'}}/></div>
        ) : (
          <div className="packs-grid">
            {packs.map((pack, i) => (
              <div key={pack.id} className={`pack-card ${i === POPULAR_INDEX ? 'pack-popular' : ''}`}>
                {i === POPULAR_INDEX && <div className="popular-badge">Most Popular</div>}
                <div className="pack-name">{pack.name}</div>
                <div className="pack-credits">{pack.credits}<span>reports</span></div>
                <div className="pack-price">{formatPrice(pack.price_cents)}</div>
                <div className="pack-per">{perReport(pack.price_cents, pack.credits)}</div>
                <button
                  className={`btn btn-full btn-lg ${i === POPULAR_INDEX ? 'btn-primary' : 'btn-outline'}`}
                  style={{marginTop:20}}
                  onClick={() => handleBuy(pack)}
                  disabled={buying === pack.id}
                >
                  {buying === pack.id ? <><div className="spinner"/>Redirecting…</> : `Buy ${pack.name}`}
                </button>
              </div>
            ))}
          </div>
        )}

        <div style={{textAlign:'center', marginTop:40, fontSize:13, color:'var(--gray-400)'}}>
          Payments processed securely by Stripe. Credits are added instantly after payment.
        </div>
      </div>
    </Layout>
  );
}
